import { render, staticRenderFns } from "./TypeSelector.vue?vue&type=template&id=7d84f8c8&"
import script from "./TypeSelector.vue?vue&type=script&lang=ts&"
export * from "./TypeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TypeSelector.vue?vue&type=style&index=0&id=7d84f8c8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports